import type { RouteObject } from 'react-router-dom';

/**
 * The `handle` of a route a signed-out visitor may open (an invite link,
 * sign-up). Every route without it sends them to sign-in first.
 */
export const OPEN_TO_SIGNED_OUT = { openToSignedOut: true } as const;

export function isOpenToSignedOut(route: RouteObject): boolean {
  return (route.handle as typeof OPEN_TO_SIGNED_OUT | undefined)?.openToSignedOut === true;
}
